import React from 'react';


const LoadingOverlay = (props) => {
    const h = props.height ? props.height : '3rem';
    const w = props.height ? props.height : '3rem';
    const color = props.color ? props.color : 'white';
    const opacity = props.opacity ? props.opacity : "0.5";
    const overlayStyle = {
        position: "absolute",
        zIndex: "9999",
        background: "rgba(0,0,0," + opacity + ")",
        display: "flex",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0"
    }
    return (
    <div style={overlayStyle}>
        <div className={"spinner-border text-" + color} style={{width: w, height: h, margin: "auto"}} role="status">
            <span className="sr-only">Loading...</span>
        </div>
    </div>);
}
export default LoadingOverlay;